function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-857 -1280)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0H36V36H0Z",
  transform: "translate(857 1280)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.56,9.339l-8.643-5a2.342,2.342,0,0,0-2.357,0l-8.643,5a2.369,2.369,0,0,0-1.179,2.043v9.979A2.369,2.369,0,0,0,5.917,23.4l8.643,5a2.342,2.342,0,0,0,2.357,0l8.643-5a2.369,2.369,0,0,0,1.179-2.043V11.382A2.369,2.369,0,0,0,25.56,9.339ZM7.881,20.905v-7.26l6.286,3.646v7.244Zm7.857-6.333L9.452,10.926,15.738,7.3l6.286,3.63Zm1.571,9.963V17.291L23.6,13.645v7.26Z",
  transform: "translate(852.262 1281.629)",
  fill: "#1fc5db"
}));

var Svg3Dreview36Px = function Svg3Dreview36Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3Dreview36Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3Dreview_36px.45a50350.svg";
export { ForwardRef as ReactComponent };